<template>
  <footer>
    <div class="project-by">
      <span class="text">{{$t('landing.by')}}</span>
      <a class="company" href="https://www.yara.com" target="_blank" rel="noopener">
        <logo-yara/>
      </a>
    </div>
  </footer>
</template>

<style lang="scss" scoped>

footer {
  display: flex;
  color: var(--color--white);
  align-items: center;
  justify-content: flex-end;
  padding: $spacing--l $spacing--m;
  background: url("~@/assets/images/pattern-bg.png"),
              var(--background--dark);
}

a,
a:visited {
  color: var(--color--white);
}

.project-by {
  display: flex;
  align-items: center;
  .text {
    margin-right: $spacing--m;
  }
}

</style>

<script>
import LogoYara from '@/components/LogoYara'

export default {
  components: {
    'logo-yara': LogoYara
  }
}
</script>
